import React, { useEffect, useState, useContext } from 'react';
import { Table, Row, Col } from 'antd';
import * as Setting from '../../utils/AuthUtils';
import AddTournament from '../../components/AddTournament';
import { generateTournamentCols } from '../../utils/DataUtils';
import { MeContext } from '../../context';
import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function FilteredTournamentsList(props) {
    const [hasRights, setHasRights] = useState({isAdmin: false, isReferral: false});
    const me = useContext(MeContext);
    const { t } = useTranslation();

    useEffect(() => {
      const isAd = (me && me.payLoad ? me.payLoad.isAdmin : false)
      const isRef = Setting.isReferral(me && me.payLoad ? me.payLoad : {}); 
      setHasRights({isAdmin: isAd, isReferral: isRef});
      }, [me])
      
      return (
        <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
          <h1>
            {t('tournaments.title').toUpperCase()}
          </h1>
          <Row>
            <Col flex="auto" style={{ textAlign: 'left' }}> 
              <h3 style={{ marginTo: '16px', textAlign: 'left' }}>Official Tournaments</h3>
            </Col>
            <Col flex="auto" style={{ textAlign: 'right' }}>
              <Link to="/full-tournaments" style={{ fontSize: '14px', marginTop: '1.33em', marginBottom: '1.33em', display: 'block' }}>See full calendar</Link>
            </Col>
          </Row>
          <Table
              style={{ marginTop: '-12px' }}
              rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
              size="small"
              columns={generateTournamentCols(t)} 
              dataSource={(props.tournaments && props.tournaments.payLoad ? props.tournaments.payLoad : [])} 
              pagination={{ pageSize: 15 }} 
              loading={props.pending}/>
          <Row style={{ marginTop: '32px' }}>
            <Col flex="auto" style={{ textAlign: 'left' }}> 
              <h3 style={{ marginTo: '16px', textAlign: 'left' }}>Supported Tournaments</h3>
            </Col>
            <Col flex="auto" style={{ textAlign: 'right' }}>
              <Link to="/full-tournaments" style={{ fontSize: '14px', marginTop: '1.33em', marginBottom: '1.33em', display: 'block' }}>See full calendar</Link>
            </Col>
          </Row>
          <Table
              style={{ marginTop: '-12px' }}
              rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
              size="small"
              columns={generateTournamentCols(t)} 
              dataSource={(props.unofficialTournaments && props.unofficialTournaments.payLoad ? props.unofficialTournaments.payLoad : [])} 
              pagination={{ pageSize: 5 }} 
              loading={props.pending}/>
        </motion.div>
    );
}

export default FilteredTournamentsList;